export default function PrimarySourceIcon() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 3.86816V8.13184L6 10.3818L1.5 8.13184L1.5 3.86816L6 1.61816L10.5 3.86816Z"
        fill="#5CDBD3"
        stroke="#13C2C2"
        strokeWidth="2"
      />
    </svg>
  );
}
